import React from 'react';
import { Table } from 'semantic-ui-react';

// Global Components
// @ts-ignore
import EntityDefaultVarietyName from 'components/EntityDefaultVarietyName';
// @ts-ignore
import TableActions from 'components/TableActions';
// @ts-ignore
import EntityOrchardRpin from 'components/EntityOrchardRpin';
// @ts-ignore
import EntityName from 'components/EntityName';
// @ts-ignore
import ForecastQuantityForecast from 'components/ForecastQuantityForecast';
// @ts-ignore
import ForecastSize from 'components/ForecastSize';
import RoleTableRowLink from 'components/RoleTableRowLink';
import RoleButtonLink from 'components/RoleButtonLink';

// Child Components
// @ts-ignore
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
// @ts-ignore
import ForecastStatus from './components/ForecastStatus';

interface Props {
    entityId?: number;
}

export default class ForecastsTableRow extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { entityId } = this.props;
        if (!entityId) {
            return null;
        }
        return (
            <RoleTableRowLink
                requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                params={{
                    selectedEntity: entityId,
                    forecastModal: true
                }}
            >
                <Table.Cell>
                    <EntityName entityId={entityId} hideEntityType />
                </Table.Cell>
                <Table.Cell>
                    <EntityOrchardRpin entityId={entityId} />
                </Table.Cell>
                <Table.Cell>
                    <EntityDefaultVarietyName entityId={entityId} />
                </Table.Cell>
                <Table.Cell>
                    <ForecastQuantityForecast quantityForecastId={entityId} />
                </Table.Cell>
                <Table.Cell>
                    <ForecastSize quantityForecastId={entityId} />
                </Table.Cell>
                <Table.Cell>
                    <ForecastStatus quantityForecastId={entityId} />
                </Table.Cell>
                <Table.Cell textAlign="right">
                    <TableActions>
                        <RoleButtonLink
                            requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                            params={{
                                selectedEntity: entityId,
                                forecastModal: true
                            }}
                        >
                            Edit
                        </RoleButtonLink>
                    </TableActions>
                </Table.Cell>
            </RoleTableRowLink>
        );
    }
}
